module.exports = __webpack_public_path__ + "assets/xianweijing.d7215515.svg";